import React, { Component } from 'react';
import {connect} from 'react-redux'
import StockTyreProductTransactionModal from './StockTyreProductTransactionModal';
import StockTyreModal from './StockTyreModal'
import { Pagination, DropdownButton, MenuItem, Button, Form, FormControl, FormGroup, InputGroup } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
import { Checkbox, Radio } from 'react-icheck';
import ConfirmPopup from 'component/element/ConfirmPopup';
import ReportStore from 'stores/ReportStore';
import StockStore from 'stores/StockStore';
import ExportTyreExcelButton from './ExportTyreExcelButton';
// import StockEditTyreModal from './StockEditTyreModal'
import './Stock.css';
// import Moment from 'moment';
import Parser from 'html-react-parser';
// import ReportMobileTable from '../../report/ReportMobileTable'

var NotificationSystem = require('react-notification-system');
const localStorageKey = 'bf.stock-tyre.cfg'
class StockTyreSearchPage extends Component {

  constructor(props) {
    super(props)
    let displayCost = {}
    if(this.props.config.showCostPerUnitField){      
      displayCost = JSON.parse(localStorage.getItem(localStorageKey)) || {showCostPerUnit:false}
    }else{
      displayCost = {showCostPerUnit:false}
    }

    this.state = ({
      loading:false,
      showConfirmDelete: false,
      countPartSelect:'',
      btnDisplay:'none',
      rowCheck:[],
      trStyle:[],
      checked:[],
      length:10,
      totalPage:0,
      activePage:1,
      data:[],
      allData:[],
      dataDd:[],
      dataSubDd:[{label:'----- ทั้งหมด -----',value:''}],
      dataInOut:[],
      defaultOption:'all',
      defaultSubOption:'',
      query:'',
      showStockProductTransactionPopup:false,
      record_type:'',
      displayCost:displayCost,
      // showPoDoc:false,
      filter:'all',
      highlight:{serial_no:[]},
      showAdd:false,
      tyreTitle:'',
      dataSet:{},
      // showEditTyreModal:false
    })
  }

  loadData() {
    this.loadStockList()
    this.loadCategory()
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  loadCategory() {
    let that = this
    StockStore.loadCategory(this.props.tool, function (result) {
      that.setState({ dataDd: result.data })
    })
  }

  loadSubCategory(value) {
    let that = this
    let dataSubDd = [{label:'----- ทั้งหมด -----',value:''}]
    StockStore.loadSubCategory(this.props.tool, value, function (result) {
      result.data.forEach((item,index)=>{
        dataSubDd.push({
          label:item.name,
          value:item.cat_id
        })
      })  
      that.setState({ dataSubDd: dataSubDd })
    })
  }
  
  loadAllData(query, cat_id, sub_cat, filter) {
    ReportStore.loadStockTyreList(this.props.tool, query, cat_id, sub_cat, (filter!=='all'?'':''), (filter!=='all'?'':''), (result)=>{
      let dataAll = []
      if (filter!=='all') {
        result.data.forEach((item,index)=>{
          if (filter==='out_stock') {
            if ((item.quantity*1)===0) {
              dataAll.push(item)
            }
          } else {
            if (item.quantity>0) {
              dataAll.push(item)
            }
          }  
        })
      } else {
        dataAll = result.data
      }
      this.setState({allData:dataAll})
    })  
  }

  loadStockList(page = 1, cat_id = '', sub_cat = '', query = '') {
    let that = this
    let {filter,length,highlight} = that.state
    highlight.serial_no.length = 10
    this.setState({ loading: true, highlight:highlight })
    let start = (page * 10) - 10
    if (page === 1) {
      start = 0
      this.setState({ activePage: page })
    }
    that.loadAllData(query, cat_id, sub_cat, filter)
    ReportStore.loadStockTyreList(this.props.tool, query, cat_id, sub_cat, (filter!=='all'?'':start), (filter!=='all'?'':length), function(result) {
      let totalPage = result.total_count / 10
      let dataMap = result.data
      if (filter!=='all') {
        dataMap = []
        let dataAll = []
        let i = 0
        if (start===0) 
          start = 10
        else {
          start = (start*1)+10
          i = start - 10
        }
        
        result.data.forEach((item,index)=>{
          if (filter==='out_stock') {
            if ((item.quantity*1)===0) {
              dataAll.push(item)
            }
          } else {
            if (item.quantity>0) {
              dataAll.push(item)
            }
          }  
        })
        totalPage = dataAll.length / 10
        dataAll.forEach((item,index)=>{
          if (index>=i&&index<start) {
            dataMap.push(item)
          }
        })  
      }

      let data = dataMap.map((item,index)=>{
        let serial_no = ''
        if (query!=='') {
          serial_no = item.serial_no.replace(query, '<span className="text-highlight">'+query+'</span>')
        } else {
          serial_no = item.serial_no
        }
        highlight.serial_no[index] = serial_no
        return item
      })
      that.refs.excelRef.getWrappedInstance().clearItem()
      that.setState({ highlight:highlight, loading: false, data: data, totalPage: Math.ceil(totalPage) })
    })
  }

  // loadStockListAfter(page = 1, cat_id = '', sub_cat = '', newData) {
  //   let that = this
  //   let {highlight} = that.state
  //   highlight.serial_no.length = 10
  //   this.setState({ loading: true, highlight:highlight })

  //   if (page == 1) {
  //     var start = 0
  //     this.setState({ activePage: page })
  //   } else {
  //     var start = (page * 10) - 10
  //   }

  //   ReportStore.loadStockList(this.props.tool, '', cat_id, sub_cat, start, 9, function(result) {
  //     let allNewData = []
  //     if (result.total_count<10) {
  //       let newSet = []
  //       let newRow = {}
  //       result.data.forEach(function(item,index) {
  //         if (item.itemnum===newData.itemnum) {
  //           newRow = item
  //         } else {
  //           newSet.push(item)
  //         }
  //       })
  //       newSet.unshift(newRow)
  //       allNewData = newSet
  //     } else {
  //       result.data.unshift(newData)
  //       allNewData = result.data
  //     }
        
  //     allNewData.forEach(function(item,index) {
  //       let serial_no = ''
  //       serial_no = item.serial_no
  //       highlight.serial_no[index] = serial_no
  //     })
  //     const totalPage = result.total_count / 10
  //     that.setState({ highlight:highlight, loading: false, data: allNewData, totalPage: Math.ceil(totalPage) })
  //     that.refs.excelRef.getWrappedInstance().clearItem()
  //   })
  // }

  onConfirmStockDelete() {
    let {dataInOut,defaultOption,defaultSubOption,query} = this.state
    let {messages} = this.props
    let that = this
    StockStore.deleteProducts(this.props.tool, dataInOut, function (result) {
      that.loadStockList(1,defaultOption,defaultSubOption,query)
      that.onCheckCancel()
      that._notificationSystem.addNotification({
        title: messages['Notification'],
        message: messages['Item Deleted Successfully'],
        level: 'info',
        position: 'tc'
      });
      that.setState({ showConfirmDelete: false })
    })
  }

  onProductDeleteClick() {
    this.setState({ showConfirmDelete: true })
  }

  onInOutOpenClick(key, e) {
    let {messages} = this.props
    let title = ''
    if (key === "export") {
      title = messages['Export Item']
    } else if (key === "import"||key === "add") {
      title = messages['Import Item']
    }
    this.setState({record_type:key,showAdd:true,tyreTitle:title})
  }

  // onPoOpenClick() {
  //   let {dataInOut} = this.state
  //   let items = dataInOut.map((item,index)=>{
  //     return {amount:'',bfId:'',costPerUnit:item.cost_per_unit,detail:item.description,discountAmount:'',discountPercent:'',exportQuantity:item.quantity,exportStock:'',itemnum:item.itemnum,partFrom:'',pricePerUnit:item.price_per_unit,productCode:item.productcode,quantity:'',rowNo:''}
  //   })
  //   this.setState({showPoDoc:true})
  //   this.refs.poDocModal.getWrappedInstance().callNewDoc(items,'')
  // }

  onInOutCancelClick() {
    let {checked,trStyle} = this.state
    checked.forEach((item, index) => {
      if (item === true) {
        checked[index] = false
        trStyle[index] = ""
      }
    })
    this.refs.excelRef.getWrappedInstance().clearItem()
    this.setState({ showAdd: false, btnDisplay: "none", dataInOut: [], rowCheck: [], trStyle: trStyle, checked: checked })
  }

  getRowStyle(item, index) {
    if (item.quantity<1) {
      return 'stock-orange-row'
    } else {
      return ''
    }
  }

  onPartClick(item, index, e) {
    let {checked,trStyle} = this.state
    if (!checked[item.itemnum]) {

      this.state.rowCheck.push(item.itemnum)
      this.state.dataInOut.push(item)
      this.setState({ rowCheck: this.state.rowCheck, dataInOut: this.state.dataInOut })

      var newColor = "#eee"
      trStyle[item.itemnum] = newColor
      checked[item.itemnum] = true
      this.setState({ trStyle: trStyle, checked: checked })

      let nItem = {}
      nItem['itemnum'] = item.itemnum
      nItem['detail'] = item.tyre_brand
      nItem['productcode'] = item.serial_no
      nItem['quantity'] = item.quantity
      nItem['tyre_model'] = item.tyre_model
      nItem['tyre_size'] = item.tyre_size
      nItem['retread_count'] = item.retread_count
      nItem['tyre_mileage'] = item.tyre_mileage
      this.refs.excelRef.getWrappedInstance().addItem(nItem)

    } else {

      var key = this.state.rowCheck.indexOf(item.itemnum);
      this.state.rowCheck.splice(key, 1)
      this.state.dataInOut.splice(key, 1)

      this.setState({ rowCheck: this.state.rowCheck, dataInOut: this.state.dataInOut })

      checked[item.itemnum] = false
      trStyle[item.itemnum] = ''
      this.setState({ trStyle: trStyle, checked:checked })

      let rItem = {}
      rItem['itemnum'] = item.itemnum
      rItem['detail'] = item.tyre_brand
      rItem['productcode'] = item.serial_no
      rItem['quantity'] = item.quantity
      rItem['tyre_model'] = item.tyre_model
      rItem['tyre_size'] = item.tyre_size
      rItem['retread_count'] = item.retread_count
      rItem['tyre_mileage'] = item.tyre_mileage
      this.refs.excelRef.getWrappedInstance().removeItem(rItem)
    }

    if (this.state.rowCheck.length > 0) {
      this.setState({ btnDisplay: "" })
    } else {
      this.setState({ btnDisplay: "none" })
    }

    this.setState({ countPartSelect: this.state.rowCheck.length })
  }

  onReload() {
    this.loadStockList(1, this.state.cat_id, this.state.defaultSubOption, this.state.query)
  }

  onUpdate(data) {
    this.setState({dataInOut:data})
  }

  handleSelect(e) {

    // let { query } = this.state
    // const cat_id = this.state.defaultOption

    // this.setState({ activePage: e, checked: [], btnDisplay: 'none', rowCheck: [], dataInOut:[], trStyle:[] })
    // this.loadStockList(e, cat_id, query)

    let { query,defaultSubOption } = this.state
    let cat_id = this.state.defaultOption
    this.setState({ activePage: e })
    this.loadStockList(e, cat_id, defaultSubOption, query)
  }

  onCategoryChange(e) {
    this.setState({ defaultOption: e.value, defaultSubOption:'' })
    this.loadSubCategory(e.value)
    this.loadStockList(1, e.value, '', '')
  }

  onSubCategoryChange(e) {
    this.setState({ defaultSubOption: e.value })
    this.loadStockList(1, this.state.defaultOption, e.value, this.state.query)
  }

  onTextChange(e) {
    this.setState({ query: e.target.value })
  }

  onSearchKeyPress(e) {
    let { query,defaultSubOption } = this.state
    const cat_id = this.state.defaultOption

    if (e.charCode === 13) {
      this.loadStockList(1, cat_id, defaultSubOption, query)
    }
  }

  onSearchClick() {
    let { query,defaultSubOption } = this.state
    const cat_id = this.state.defaultOption
    this.loadStockList(1, cat_id, defaultSubOption, query)
  }

  onStockProductTransactionOpenClick(item,e) {
    this.setState({dataSet:item,showStockProductTransactionPopup:true})
  }

  onStockProductTransactionCloseClick() {
    this.setState({showStockProductTransactionPopup:false,dataSet:{}})
  }

  // onHideCostChange(e) {
  //   let {displayCost} = this.state
  //   displayCost.showCostPerUnit = !displayCost.showCostPerUnit
  //   localStorage.setItem(localStorageKey, JSON.stringify(displayCost))
  //   this.setState({displayCost:displayCost})
  // }

  // onRowWorkClick(item,items) {
  //   this.onStockProductTransactionOpenClick(items)
  // }

  onExportExcelClick() {
    let {btnDisplay,allData} = this.state
    if (btnDisplay==='none') {
      let setData = allData.map((item,index)=>{
        return {itemnum:item.itemnum,detail:item.tyre_brand,productcode:item.serial_no,quantity:item.quantity,tyre_model:item.tyre_model,tyre_size:item.tyre_size,retread_count:item.retread_count,tyre_mileage:item.tyre_mileage}
      })
      this.refs.excelRef.getWrappedInstance().setItem(setData)
    }
    this.refs.excelRef.getWrappedInstance().onClick()
  }

  onCheckCancel() {
    this.onInOutCancelClick()
  }

//   renderMobileTable() {
//     let {data} = this.state
//     let fieldMap = {title:'description',amount:'_amount',sub_title:'productcode',date:'name',status:'',sub_status:''}
//     let _data = []
//     _data = data.map((item,index)=>{
//       let _item = item
//       _item = Object.assign({_amount:item.quantity+' '+item.unit}, _item)
//       return _item
//     })
//     return(
//       <div>
//         <ReportMobileTable
//           itemlist={_data}
//           fieldMap={fieldMap}
//           keyIndex={'itemnum'}
//           numberFormat={false}
//           onRowClick={this.onRowWorkClick.bind(this)}
//         />
//       </div>
//     )
//   }

  onFilterItemChange(value) {
    let {filter,defaultOption,defaultSubOption,query} = this.state
    filter = value
    this.setState({filter:filter,activePage:1}) 
    setTimeout(()=>{
      this.loadStockList(1,defaultOption,defaultSubOption,query)
    },100) 
 
  }

  onEditTyreSaveClick() {
    let {messages} = this.props
    let {dataSet,activePage,defaultOption,defaultSubOption,query} = this.state
    let postData = dataSet
    postData.description = '-'
    StockStore.saveProduct(this.props.tool, postData, (result) => {
      // this.setState({showEditTyreModal:false})
      if (result.status === 'OK') {
        this._notificationSystem.addNotification({
          title: messages['Notification'],
          message: messages['Save Item']+' [' + postData.serial_no + '] '+messages['Successfully'],
          level: 'info',
          position: 'tc'
        });
        this.loadStockList(activePage, defaultOption, defaultSubOption, query)
      }
    },()=>{
      // this.setState({showEditTyreModal:false})
      this._notificationSystem.addNotification({
        title: messages['Notification'],
        message: messages['Can Not Save Item, Please Try Again.'],
        level: 'error',
        position: 'tc'
      });
    })    
  }

  renderTable() {
    return(
        <div className='table-responsive'>
          <table className="table table-hover table-bordered-solid">
            <thead>
              <tr>
                <th style={{width:'50px'}} className="text-center"></th>
                <th style={{width:'100px'}} className="text-center">หมายเลขยาง</th>
                <th style={{width:'90px'}} className="text-center">ยี่ห้อ</th>
                <th style={{width:'90px'}} className="text-center">รุ่น</th>
                <th style={{width:'90px'}} className="text-center">ขนาดยาง</th>
                <th style={{width:'90px'}} className="text-center">จำนวนครั้งที่<br />หล่อดอก</th>
                <th style={{width:'90px'}} className="text-center">จำนวน กม.</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
          </table>
        </div>
    )
  }

  renderRowData() {
    let {data,highlight} = this.state
    if (data.length===0) {
      return (<tr><td colSpan={7}>{this.props.messages['Data Not Found']}</td></tr>)
    } else {
        return (
            data.map((item, index) => {
                return(
                    <tr key={index} className={this.getRowStyle(item, index)} style={{ backgroundColor: this.state.trStyle[item.itemnum] }}>
                        <td className="text-center">
                            <Checkbox
                                onChange={this.onPartClick.bind(this, item, index)}
                                checked={this.state.checked[item.itemnum]}
                                checkboxClass="icheckbox_square-blue"
                                increaseArea="20%"
                                label=""
                                >
                            </Checkbox>
                        </td>
                        <td onClick={this.onStockProductTransactionOpenClick.bind(this,item)}>
                            {Parser('<div>'+highlight.serial_no[index]+'</div>')}
                        </td>
                        <td onClick={this.onStockProductTransactionOpenClick.bind(this,item)}>{item.tyre_brand}</td>
                        <td onClick={this.onStockProductTransactionOpenClick.bind(this,item)} className="text-center">{item.tyre_model}</td>
                        <td onClick={this.onStockProductTransactionOpenClick.bind(this,item)} className="text-center">{item.tyre_size}</td>
                        <td onClick={this.onStockProductTransactionOpenClick.bind(this,item)} className="text-center">{item.retread_count}</td>
                        <td onClick={this.onStockProductTransactionOpenClick.bind(this,item)} className="text-center">{item.tyre_mileage}</td>
                    </tr>
                )
            })
        )
    }
  }

  render() {
    let {messages} = this.props
    let {loading,showConfirmDelete,dataSubDd,showAdd,record_type,tyreTitle,dataInOut} = this.state
    // const title = <div><FontAwesome name='shopping-cart' className="color-orange" /> {messages['Create Order']}</div>
    const title2 = <div><FontAwesome name='arrow-down' className="color-blue" /> {messages['Create Export Item']}</div>
    const title3 = <div><FontAwesome name='arrow-up' className="color-green" /> {messages['Create Import Item']}</div>
    const title4 = <div><FontAwesome name='trash' className="color-red" /> {messages['Remove Item']}</div>
    // const title5 = <div><FontAwesome name='industry' className="color-black" /> ย้ายรายการไปคลังสินค้าอื่น</div>
    const title6 = <div><FontAwesome name='file-excel-o' className="color-green" /> รายการไฟล์ Excel</div>
    const title7 = <div><FontAwesome name='ban' className="color-red" /> ยกเลิกเลือกรายการ</div>

    const options = [{ "value": "all", "label": "----- "+messages['All']+" -----" }]
    this.state.dataDd.forEach((item, index) =>
      options.push({
        value: item.cat_id,
        label: item.name
      })
    )
    
    let dTitle = (<span><FontAwesome name='list' />&nbsp;{messages['Manage Item']}</span>)
    let boxTitle = 'ค้นหาคลังยางใช้งาน'
    if (this.props.tool === 'retiredtyre') {
      boxTitle = 'ค้นหาคลังยางหมดสภาพ'
    }

    // let showCostCb = (this.props.tool==="genpart" && this.props.config.showCostPerUnitField)

    return (
      <div>
        <Box loading={loading}>
          <Box.Header border={false}>
            <Box.Title>{boxTitle}</Box.Title>
            <Box.Tools>
              <Button
                bsStyle={'link'} 
                className='text-large'
                onClick={this.onInOutOpenClick.bind(this,'add')}
              >
                <FontAwesome name='plus' /> {messages['Add Item']}
              </Button>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            <Form inline style={{marginBottom:'5px'}}>
              <FormGroup>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={this.state.defaultOption}
                  options={options}
                  style={{ width: "200px" }}
                  onChange={this.onCategoryChange.bind(this)}
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <Select
                  clearable={false}
                  name="form-field-name"
                  value={this.state.defaultSubOption}
                  options={dataSubDd}
                  style={{ width: "200px" }}
                  onChange={this.onSubCategoryChange.bind(this)}
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <InputGroup>
                  <InputGroup>
                    <FormControl type="text" placeholder={messages['Item Name']+"..."} onChange={this.onTextChange.bind(this)} onKeyPress={this.onSearchKeyPress.bind(this)} />
                    <InputGroup.Addon className="btn" onClick={this.onSearchClick.bind(this)}>
                      <FontAwesome name='search' />
                    </InputGroup.Addon>
                  </InputGroup>
                </InputGroup>
              </FormGroup>
              {' '}
              <FormGroup>
                <Radio
                  onChange={this.onFilterItemChange.bind(this,'all')}
                  checked={this.state.filter==='all'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label=" ทั้งหมด"
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <Radio
                  onChange={this.onFilterItemChange.bind(this,'in_stock')}
                  checked={this.state.filter==='in_stock'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label=" อยู่ในสต็อก"
                />
              </FormGroup>
              {' '}
              <FormGroup>
                <Radio
                  onChange={this.onFilterItemChange.bind(this,'out_stock')}
                  checked={this.state.filter==='out_stock'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label=" ไม่อยู่ในสต็อก"
                />
              </FormGroup>
              {' '}
              <FormGroup style={{display: this.state.btnDisplay}}>
                <FormControl readOnly={true} value={'ได้เลือก '+this.state.countPartSelect+' รายการ'} />
              </FormGroup>
              {' '}
              <DropdownButton bsStyle="primary" title={dTitle} id='dd-tyre'>
                <MenuItem eventKey="2" onClick={this.onInOutOpenClick.bind(this, 'export')}>{title2}</MenuItem>
                <MenuItem eventKey="3" onClick={this.onInOutOpenClick.bind(this, 'import')}>{title3}</MenuItem>
                <MenuItem divider />
                {/* {this.props.tool=='genpart'?<MenuItem eventKey="1" onClick={this.onPoOpenClick.bind(this)}>{title}</MenuItem>:''}
                {this.props.tool=='genpart'?<MenuItem divider />:''} */}
                {/* {this.props.tool!='tool'?<MenuItem eventKey="5" onClick={this.onInOutOpenClick.bind(this, 'transfer')}>{title5}</MenuItem>:''} */}
                {/* {this.props.tool!='tool'?<MenuItem divider />:''} */}
                <MenuItem eventKey="6" onClick={this.onExportExcelClick.bind(this)}>{title6}</MenuItem>
                {this.state.btnDisplay===''?<MenuItem divider />:''}
                {this.state.btnDisplay===''?<MenuItem eventKey="7" onClick={this.onCheckCancel.bind(this)}>{title7}</MenuItem>:''}
                {this.state.btnDisplay===''?<MenuItem eventKey="4" onClick={this.onProductDeleteClick.bind(this)}>{title4}</MenuItem>:''}
              </DropdownButton>
              {/* {' '}
              <FormGroup style={{display:(showCostCb?'':'none')}}>
                <Checkbox
                  onChange={this.onHideCostChange.bind(this)}
                  checked={!displayCost.showCostPerUnit}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={" "+messages['Hide Cost']}
                  >
                </Checkbox>
              </FormGroup> */}
            </Form>
            {/* {isMobile?this.renderMobileTable():this.renderTable()} */}
            {this.renderTable()}
          </Box.Body>
        </Box>
        <div>
          <div className="text-right">
            <Pagination
              prev={messages['Previous']}
              next={messages['Next']}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this)}
            />
          </div>
        </div>
        <NotificationSystem ref="notificationSystem" />
        <ConfirmPopup show={showConfirmDelete}
          title={messages['Confirm']}
          message={messages['Confirm Deletion Of Item']}
          confirmTitle={messages['Confirm']}
          onConfirm={this.onConfirmStockDelete.bind(this)}
          onHide={() => { this.setState({ showConfirmDelete: false }) }}
        />
        <ExportTyreExcelButton 
          ref='excelRef' 
          showBtn={false}
          btnDisplay={this.state.btnDisplay}
          stockType='tyre'
        />
        <StockTyreModal
            show={showAdd}
            tool={this.props.tool}
            recordType={record_type}
            title={tyreTitle}
            data={dataInOut}
            onHide={()=>{this.setState({showAdd:false,record_type:'',tyreTitle:''})}}
            onCancel={this.onInOutCancelClick.bind(this)}
            onReload={this.onReload.bind(this)}
            onUpdate={this.onUpdate.bind(this)}
        />
        <StockTyreProductTransactionModal
          show={this.state.showStockProductTransactionPopup}
          onHide={this.onStockProductTransactionCloseClick.bind(this)}
          stockType={this.props.tool}
          itemData={this.state.dataSet}    
          tool={this.props.tool}
          onEditTyreSaveClick={this.onEditTyreSaveClick.bind(this)}        
        />
        {/* <StockEditTyreModal
          show={this.state.showEditTyreModal}
          dataSet={this.state.dataSet}
          tool={this.props.tool}
          stockType={this.props.tool}
          onHide={()=>{this.setState({showEditTyreModal:false})}}
          onSave={this.onEditTyreSaveClick.bind(this)}
        /> */}
      </div>
    )
  }
}


export default StockTyreSearchPage = connect(
  (state) => ({messages: state.message.view.tyre.stock.StockTyreSearchPage}),null,null,{withRef:true}
)(StockTyreSearchPage);





// WEBPACK FOOTER //
// ./src/view/tyre/stock/StockTyreSearchPage.js